import { IAgreementResponse, IAgreementDetailResponse } from "../../../model/base/response/agreement-response";
import { Pagination } from "../../../model/paginatiion";

export enum ACTION_TYPES {
    SET_AGREEMENTS = 'SET_AGREEMENTS',
    CLEAR_AGREEMENTS = 'CLEAR_AGREEMENTS',
    SET_AGREEMENT_DETAIL = 'SET_AGREEMENT_DETAIL'
}

export interface IAgreementsState {
    agreements: Pagination<IAgreementResponse>;
    agreementDetail: IAgreementDetailResponse | null;
}

export const initialState: IAgreementsState = {
    agreements: new Pagination<IAgreementResponse>(),
    agreementDetail: null
};

export type Action =
    | { type: ACTION_TYPES.SET_AGREEMENTS; payload: Pagination<IAgreementResponse> }
    | { type: ACTION_TYPES.CLEAR_AGREEMENTS }
    | { type: ACTION_TYPES.SET_AGREEMENT_DETAIL; payload: IAgreementDetailResponse };

export const agreementsReducer = (state: IAgreementsState, action: Action): IAgreementsState => {
    switch (action.type) {
        case ACTION_TYPES.SET_AGREEMENTS:
            return { ...state, agreements: action.payload };
        case ACTION_TYPES.CLEAR_AGREEMENTS:
            return { ...state, agreements: new Pagination<IAgreementResponse>() };
        case ACTION_TYPES.SET_AGREEMENT_DETAIL:
            return { ...state, agreementDetail: action.payload };
        default:
            throw new Error(`Unhandled action type`);
    }
};
